window.addEventListener('load', () => {
  const main = document.querySelector('main')
  if (!main || !main.classList.contains('archive')) return

  const wrapper = document.querySelector('.list_wrapper[data-role="pager"]')
  const list = document.querySelector('.js-ajax-target')
  const pager = document.querySelector('.js-ajax-pager')
  if (!wrapper || !list || !pager || !window.NA_RECIPE_PAGER) return

  const listAnchor = document.getElementById('list')
  const headerOffset = document.querySelector('header')?.offsetHeight || 0
  const scrollToList = () => {
    if (!listAnchor) return
    const y = listAnchor.getBoundingClientRect().top + window.scrollY - headerOffset - 8
    const prefersReduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches
    window.scrollTo({ top: y, behavior: prefersReduced ? 'auto' : 'smooth' })
    listAnchor.setAttribute('tabindex', '-1')
    listAnchor.focus?.()
  }

  const { ajax_url } = window.NA_RECIPE_PAGER
  let { nonce } = window.NA_RECIPE_PAGER // ★ 後で差し替えるので let
  const postType = wrapper.dataset.postType || 'recipe'
  const tax = wrapper.dataset.tax || 'ingredients'  // ★ フォールバック
  const termId = Number(wrapper.dataset.termId) || 0

  const mq = window.matchMedia('(max-width: 768px)')
  let perPage = parseInt(wrapper.dataset.perPage || '9', 10) || 9
  if (mq.matches) perPage = 5

  let loading = false

  // ★ 追加：最新 nonce を取得
  const refreshNonce = () =>
    fetch(ajax_url, {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8' },
      body: new URLSearchParams({ action: 'na_recipe_nonce' }),
    })
      .then((r) => r.json())
      .then((json) => {
        if (json && json.success && json.data?.nonce) {
          nonce = json.data.nonce
          return true
        }
        return false
      })
      .catch(() => false)

  // ★ 追加：実コール（失敗したら nonce を更新して 1 リトライ）
  const requestPage = (page, triedRefresh = false) =>
    fetch(ajax_url, {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8' },
      body: new URLSearchParams({
        action: 'na_recipe_paged',
        nonce,
        page,
        post_type: postType,
        tax,
        term_id: termId,
        per_page: String(perPage),
      }),
    }).then(async (r) => {
      // 403/401 などで落ちたら一度だけ nonce を更新してリトライ
      if (!r.ok && !triedRefresh) {
        const ok = await refreshNonce()
        if (ok) return requestPage(page, true)
      }
      return r.json()
    })

  const loadPage = (page) => {
    if (loading) return Promise.resolve()
    loading = true
    wrapper.classList.add('is-loading')

    return requestPage(page)
      .then((json) => {
        if (!json || !json.success) return
        list.innerHTML = json.data.items_html
        pager.innerHTML = json.data.pager_html

        const url = new URL(location.href)
        url.searchParams.set('page', page)
        history.replaceState(null, '', url.toString())
        scrollToList()
      })
      .catch(() => {})
      .finally(() => {
        loading = false
        wrapper.classList.remove('is-loading')
      })
  }

  pager.addEventListener('click', (e) => {
    const el = e.target.closest('[data-page]')
    if (!el) return
    e.preventDefault()

    const page = parseInt(el.dataset.page || '1', 10)
    if (
      isNaN(page) ||
      page < 1 ||
      el.classList.contains('is-current') ||
      el.classList.contains('disabled')
    )
      return
    loadPage(page)
  })

  mq.addEventListener('change', (e) => {
    perPage = e.matches ? 5 : parseInt(wrapper.dataset.perPage || '9', 10) || 9
    loadPage(1)
  })

  const urlPage = parseInt(new URL(location.href).searchParams.get('page') || '1', 10)
  loadPage(urlPage)

  console.log('[pager]', {
    tax: wrapper.dataset.tax,
    termId: wrapper.dataset.termId,
    perPage,
  })
})
